import { createSelector } from 'reselect'
import * as CardRelationTypes from 'const/CardRelationTypes'

const cardRelationsSortMap = {
  [CardRelationTypes.CHILD]: 4,
  [CardRelationTypes.PARENT]: 1,
  [CardRelationTypes.SUCCESSOR]: 3,
  [CardRelationTypes.PREDECESSOR]: 2
}

const getCardRelations = (state, props) => {
  return state.kanbo.cardRelations.byId[props.cardContext.id]
}

const createCardRelationsSelector = () => createSelector(
  [
    getCardRelations,
    state => state['view-board'].cards,
  ],
  (
    cardRelations,
    cardsById,
  ) => {
    if (!cardRelations) {
      return []
    }

    const groupMap = new Map<number, number[]>()

    const relations = [
      ...cardRelations.parentIds.map(id => ({
        id,
        type: CardRelationTypes.PARENT
      })),
      ...cardRelations.predecessorIds.map(id => ({
        id,
        type: CardRelationTypes.PREDECESSOR
      })),
      ...cardRelations.successorIds.map(id => ({
        id,
        type: CardRelationTypes.SUCCESSOR
      })),
      ...cardRelations.childIds.map(id => ({
        id,
        type: CardRelationTypes.CHILD
      }))
    ]

    relations.sort((a, b) => {
        const nameA = cardsById[a.id] ? cardsById[a.id].name.toUpperCase() : null
        const nameB = cardsById[b.id] ? cardsById[b.id].name.toUpperCase() : null
        return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0
      })
      .forEach(({ id, type }) => {
        let cardIds = groupMap.get(type)

        if (!cardIds) {
          cardIds = []

          groupMap.set(type, cardIds)
        }

        cardIds.push(id)
      })

    return Array.from(groupMap)
      .map(([ type, cardIds ]) => ({
        type,
        cardIds,
      }))
      .sort((a, b) => {
        if (cardRelationsSortMap[a.type] < cardRelationsSortMap[b.type]) {
          return -1
        }

        if (cardRelationsSortMap[a.type] > cardRelationsSortMap[b.type]) {
          return 1
        }

        return 0
      })
  }
)

export const getId = (state, props) => props.cardContext.id

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export default () => {
  const cardRelationsSelector = createCardRelationsSelector()

  return createSelector(
    [
      getId,
      getIsArchived,
      cardRelationsSelector,
      (state, props) => state.kanbo.cardRelations.byId[props.cardContext.id]?.defaultParentId
    ],
    (
      id,
      isArchived,
      relations,
      defaultParentId,
    ) => ({
      id,
      isArchived,
      relations,
      defaultParentId,
    })
  )
}
